import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import desktopLogoBlack from "../../src/assets/images/logo_black.png";
import "@fortawesome/fontawesome-svg-core/styles.css"; // Import the Font Awesome CSS
import { config } from "@fortawesome/fontawesome-svg-core";
import { useResetPasswordMutation } from "../services/useResetPasswordMutation";
config.autoAddCss = false;

const ResetPasswordPage = () => {
  const [passwordError, setPasswordError] = useState("");
  const [showPassword, setShowPassword] = useState({
    password: false,
    confirmPassword: false,
  });
  const navigate = useNavigate();
  const location = useLocation();
  const { mutateAsync: resetPassword, isLoading: loading } =
    useResetPasswordMutation();
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
    watch,
  } = useForm({
    defaultValues: {
      password: "",
      confirmPassword: "",
    },
    mode: "onBlur",
  });

  const token =
    new URLSearchParams(location.search).get("token") ||
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJlbWFpbCI6Imdxa2ZwaXJ0ZHJlZHdhZmppcUB5dG5oeS5jb20iLCJzZXJ2aWNlX3R5cGVfaWQiOjIsImlhdCI6MTczOTgyNDQzNCwiZXhwIjoxNzM5ODQ2MDM0fQ.R9FLWXJR6VliLb3cNa9tXTAVc7t-f9ZREHcmjHaYzhc";

  const onSubmit = async (data) => {
    setPasswordError("");

    if (data.password !== data.confirmPassword) {
      setPasswordError("Passwords do not match");

      return;
    }
    try {
      const payload = {
        token: token,
        newPassword: data.password,
      };
      const res = await resetPassword(payload);

      if (res && res.success) {
        const successMessage = res?.message || "success";
        let data = res?.data?.data;

        toast.success(successMessage);
        reset();
        navigate("/login");
      } else {
        console.log(res, "res");
        const errorMessage = res?.data[0]?.msg ?? res.message;

        toast.error(errorMessage);
        reset();
      }
    } catch (error) {
      console.error("Login failed with error:", error);
    }
  };

  const password = watch("password");

  const togglePasswordVisibility = (field) => {
    setShowPassword((prevState) => ({
      ...prevState,
      [field]: !prevState[field],
    }));
  };

  return (
    <div className="flex min-h-screen w-full items-center justify-center bg-primary/20">
      <div className="max-w-md w-full p-6 bg-white rounded-md shadow-md">
        <div
          className="mb-2 flex justify-center"
          onClick={() => {
            window.location.href = "https://qualiphy.me/";
          }}
        >
          <img
            src={desktopLogoBlack}
            alt="desktop logo"
            className="cursor-pointer w-full h-auto object-contain"
            style={{ maxHeight: "100px" }}
          />
        </div>
        <div className="mb-6 text-center">
          <h2 className="text-2xl font-semibold mb-2">Reset Password</h2>
          <p className="text-gray-600">Enter your new password</p>
        </div>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="mb-4">
            <label
              htmlFor="password"
              className="block text-gray-700 text-sm font-bold mb-2"
            >
              Password
            </label>
            <div className="relative">
              <input
                type={showPassword.password ? "text" : "password"}
                id="password"
                className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${
                  errors.password ? "border-red-500" : ""
                }`}
                placeholder="Password"
                {...register("password", {
                  required: "Please enter a password",
                  minLength: {
                    value: 8,
                    message: "Password must be at least 8 characters",
                  },
                })}
              />
              <button
                type="button"
                className="absolute inset-y-0 right-0 px-3 flex items-center focus:outline-none"
                onClick={() => togglePasswordVisibility("password")}
              >
                <FontAwesomeIcon
                  icon={showPassword.password ? faEyeSlash : faEye}
                  className="text-gray-500 hover:text-gray-700"
                />
              </button>
            </div>
            {errors.password && (
              <p className="text-red-500 text-xs italic">
                {errors.password?.message}
              </p>
            )}
          </div>

          <div className="mb-4">
            <label
              htmlFor="confirmPassword"
              className="block text-gray-700 text-sm font-bold mb-2"
            >
              Confirm Password
            </label>
            <div className="relative">
              <input
                type={showPassword.confirmPassword ? "text" : "password"}
                id="confirmPassword"
                className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${
                  errors.confirmPassword ? "border-red-500" : ""
                }`}
                placeholder="Confirm Password"
                {...register("confirmPassword", {
                  required: "Please confirm your password",
                  validate: (value) =>
                    value === password || "Passwords do not match",
                })}
              />
              <button
                type="button"
                className="absolute inset-y-0 right-0 px-3 flex items-center focus:outline-none"
                onClick={() => togglePasswordVisibility("confirmPassword")}
              >
                <FontAwesomeIcon
                  icon={showPassword.confirmPassword ? faEyeSlash : faEye}
                  className="text-gray-500 hover:text-gray-700"
                />
              </button>
            </div>
            {errors.confirmPassword && (
              <p className="text-red-500 text-xs italic">
                {errors.confirmPassword?.message}
              </p>
            )}
          </div>

          {passwordError && (
            <div className="mb-2">
              <p className="text-red-500">{passwordError}</p>
            </div>
          )}

          <div className="mb-4">
            <button
              type="submit"
              disabled={loading}
              className={`bg-[#8058FA] hover:bg-[#6344c7] text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline w-full ${
                loading ? "opacity-50 cursor-not-allowed" : ""
              }`}
            >
              {loading ? "Reset Password..." : "Reset Password"}
            </button>
          </div>
        </form>
        <div
          className="flex items-center justify-center gap-3 hover:text-slate-700 cursor-pointer"
          onClick={() => navigate("/forgot-password")}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="w-5 h-5"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M6.75 15.75L3 12m0 0l3.75-3.75M3 12h18"
            />
          </svg>
          <p>Back to Forgot Password</p>
        </div>
      </div>
    </div>
  );
};

export default ResetPasswordPage;
